import React, { useState, useEffect, useRef }from 'react';
import { Table, Form, Row, Col, Button } from 'react-bootstrap';
import { IoAdd } from 'react-icons/io5';
import { firestore } from '../../firebase';
import { Link } from 'react-router-dom';

export default function CustomersTable() {
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [customers, setCustomers] = useState([]);
    const [query, setQuery] = useState(firestore.collection('clientes').orderBy('nombre').limit(20));
    const limit = useRef(20);
    const customersLength = useRef(0);

    function getCustomers() {
        setLoading(true);
        query.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    nombre: data.nombre,
                    correo: data.correo,
                    telefono: data.telefono,
                    direccion: data.direccion,
                    notas: data.notas
                })
            })
            customersLength.current = items.length;
            setCustomers(items);
            setLoading(false);
        })
    }

    function createQuery(e) {
        e.preventDefault();
        let newQuery = firestore.collection('clientes');

        if (search) {
            const searchArray = search.toLowerCase().split(' ')
            newQuery = newQuery.where('keywords', 'array-contains-any', searchArray)
        }

        setQuery(newQuery.orderBy('nombre').limit(limit.current));
    }

    function handleScroll(e) {
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = window.innerHeight + window.pageYOffset;
        if (Math.ceil(windowBottom) >= docHeight && customersLength.current === limit.current) {
            limit.current = limit.current+20;
            createQuery(e);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getCustomers();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    return (
        <>
            <Form onSubmit={createQuery}>
                <Row className="m-2">
                    <Col className="my-1" xs={12} sm={8} md={9}>
                        <Form.Group controlId="searchBar">
                            <Form.Control 
                            type="text" 
                            placeholder="Buscar por nombre, correo, teléfono, dirección..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col className="my-1" xs={12} sm={4} md={3}>
                        <Button type="submit">Buscar</Button>
                        <Button className="mx-1 py-0 px-1" href="/customers/create" style={{fontSize: "1.55rem"}}>
                            <IoAdd/>
                        </Button>
                    </Col>
                </Row>
            </Form>
            <Table responsive striped bordered className='m-auto'>
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Correo</th>
                        <th>Teléfono</th>
                        <th>Dirección</th>
                        <th>Notas</th>
                    </tr>
                </thead>
                <tbody>
                    {customers && 
                    customers.map(customer => {
                        return (
                            <tr key={customer.id}>
                                <td>  
                                    <Link to={`/customers/view_${customer.id}`}>
                                        {customer.nombre}
                                    </Link>
                                </td>
                                <td>{customer.correo}</td>
                                <td>{customer.telefono}</td>
                                <td>{customer.direccion}</td>
                                <td>{customer.notas}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            {loading && <h3 className="text-muted m-3">Cargando...</h3>}
        </>
    )
}